import { render, staticRenderFns } from "./RoleTraining.vue?vue&type=template&id=76a3bbdd"
import script from "../../scripts/pages/RoleTraining.js?vue&type=script&lang=js&external"
export * from "../../scripts/pages/RoleTraining.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports